import {Component, OnInit, Renderer2} from '@angular/core';
import {ICsDetailMetaData} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js.interface';
import {CsAgGridJsService} from '@app/shared/cs-ag-grid-js/cs-ag-grid-js.service';

@Component({
    selector: 'app-cs-ag-grid-detail-cell-renderer',
    templateUrl: './cs-ag-grid-detail-cell-renderer.component.html',
    styleUrls: ['../../../../features/v5-common-styles/utils.scss']
})
export class CsAgGridDetailCellRendererComponent implements OnInit {

    params: any;
    rowNode: any;
    colId: string;
    toggleOnWholeCell = false;
    constructor(
        private _renderer: Renderer2,
        private _csAgGrid: CsAgGridJsService
        ) {
    }

    ngOnInit() {
        this.rowNode = this.params.node;
        this.colId = this.params.column.getColId();
        this.toggleOnWholeCell = this.params.toggleOnWholeCell || false;
    }

    get isCellExpanded() {
        const isExpanded = this.rowNode['expandedColId'] === this.colId;
        this.setCellExpansionClass(isExpanded);
        return isExpanded;
    }

    toggleDetailGrid() {
        if (this.rowNode.expanded) {
            if (this.rowNode['expandedColId'] !== this.colId) {
                this.rowNode.setExpanded(false);
                this.rowNode['expandedColId'] = null;
                this.setDetailData();
            }
        } else {
            this.setDetailData();
        }

        this.setExpanded();
    }

    setExpanded() {
        this.rowNode.setExpanded(!this.rowNode.expanded);
        this.params.api.refreshCells();
        this.rowNode['expandedColId'] = this.rowNode.expanded ? this.colId : null;
    }

    private setDetailData() {
        this.rowNode['detailMetaData'] = {
            data: this.rowNode.data,
            colId: this.colId,
            rowNode: this.rowNode,
            updateCellValue: this.updateCellValue
        } as ICsDetailMetaData;
    }

    private setCellExpansionClass(isExpanded: boolean) {
        this._renderer[isExpanded ? 'addClass' : 'removeClass'](this.params.eGridCell, 'cell-expanded');
    }

    private updateCellValue = (rowData: object) => {
        this._csAgGrid.updateNodeCellValue(this.rowNode, rowData);
    }
}
